export class AboutModel {
  title: any;
  icons: any;
  uri: string; 
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/about/aboutModel.tsx